<template>
  <!-- Bọc ngoài bằng toolbar-card chuẩn style Album -->
  <div class="wrap-item">
    <div style="margin-bottom: 12px;">
      <p class="card-title">Bộ lọc tìm kiếm</p>
      <p class="card-subtitle">Tìm kiếm dữ liệu điểm danh theo ngày, khối, lớp và trạng thái của học sinh</p>
    </div>

    <div class="wrap-toolbar">
      <!-- Khối bên trái: Chứa toàn bộ bộ lọc đầu vào -->
      <div class="toolbar-left">
        <el-date-picker
            v-model="localDate"
            type="date"
            placeholder="Chọn ngày"
            format="dd-MM-yyyy"
            value-format="yyyy-MM-dd"
            class="toolbar-datepicker"
            @change="applyFilter"
            :clearable="false"
            :editable="false"
        />

        <el-select
            v-model="localGrade"
            placeholder="Chọn khối"
            class="toolbar-select"
            v-if="localType === 'class'"
            @change="handleGradeChange"
        >
          <el-option
              v-for="item in gradeOfSchoolList"
              :key="item.id"
              :value="item.id"
              :label="item.gradeName"
          />
        </el-select>

        <el-select
            v-model="localClass"
            placeholder="Chọn lớp"
            class="toolbar-select"
            @change="applyFilter"
            v-if="localType === 'class'"
        >
          <el-option
              v-for="item in classList"
              :key="item.id"
              :value="item.id"
              :label="item.className"
          />
        </el-select>

        <el-select
            v-model="localGroup"
            placeholder="Chọn nhóm"
            class="toolbar-select"
            @change="applyFilter"
            v-if="localType === 'group'"
        >
          <el-option
              v-for="item in groupList"
              :key="item.id"
              :value="item.id"
              :label="item.nameGroup"
          />
        </el-select>

        <el-select
            v-model="localAttendanceChecked"
            placeholder="Trạng thái điểm danh"
            class="toolbar-select toolbar-select--wide"
            clearable
            @change="applyFilter"
        >
          <el-option label="Đã điểm danh" :value="true"/>
          <el-option label="Chưa điểm danh" :value="false"/>
        </el-select>

        <el-select
            v-model="localAttendanceStatus"
            placeholder="Trạng thái"
            class="toolbar-select"
            clearable
            @change="applyFilter"
        >
          <el-option label="Đi học" value="PRESENT"/>
          <el-option label="Có phép" value="ABSENT_CP"/>
          <el-option label="Không phép" value="ABSENT_KP"/>
        </el-select>
      </div>

      <!-- Khối bên phải: Chứa nút hành động phụ trợ -->
      <div class="toolbar-right">
        <el-button
            icon="el-icon-refresh"
            type="info"
            plain
            class="btn-action"
            @click="resetFilter"
        >
          Làm mới
        </el-button>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import AttendanceV3Service from "@/attendance_v3/services/AttendanceV3Service";

export default {
  name: 'AttendanceFilterBar',
  props: {
    date: { type: String, default: () => new Date().toISOString().substring(0, 10) },
    idClass: { type: [Number, String], default: null },
    idGrade: { type: [Number, String], default: null },
    idGroup: { type: [Number, String], default: null },
    attendanceChecked: { type: [String, Boolean], default: null },
    attendanceStatus: { type: String, default: null },
    type: { type: String, default: null },
  },
  data() {
    return {
      localDate: this.date,
      localClass: this.idClass,
      localGrade: this.idGrade,
      localGroup: this.idGroup,
      localAttendanceChecked: this.attendanceChecked,
      localAttendanceStatus: this.attendanceStatus,
      localType: this.type,
      groupList: []
    }
  },

  async created() {
    await this.$store.dispatch('gradeModule/fetchDataGradeOfSchoolList');
    if (this.getAppTypeUserLogin === "plus") {
      await this.$store.dispatch('classStore/fetchDataClassListCommon');
    } else {
      await this.$store.dispatch('classStore/fetchDataClassInTeacher');
    }

    // set grade
    if (this.gradeOfSchoolList.length > 0) {
      this.localGrade = this.gradeOfSchoolList[0].id;
    }

    let classes = [];
    if (this.getAppTypeUserLogin === "plus") {
      classes = this.classListCommon.filter(x => x.idGrade === this.localGrade);
    } else if (this.getAppTypeUserLogin === "teacher") {
      classes = this.classInTeacher;
    } else {
      classes = this.classListCommon;
    }

    if (classes.length > 0) {
      this.localClass = classes[0].id;
    }

    await this.$nextTick();
    await this.getAllGroup();
    this.applyFilter();
  },

  computed: {
    ...mapState('gradeModule', ['gradeOfSchoolList']),
    ...mapGetters('classStore', ['classInTeacher']),
    ...mapState('classStore', ['classListCommon']),
    classList() {
      if (this.getAppTypeUserLogin === "plus") {
        return this.classListCommon.filter((x) => x.idGrade === this.localGrade)
      } else if (this.getAppTypeUserLogin === "teacher") {
        return this.classInTeacher;
      } else return this.classListCommon
    },
    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },
  },
  methods: {
    applyFilter() {
      this.$emit('change', {
        date: this.localDate,
        idClass: this.localClass,
        idGrade: this.localGrade,
        attendanceChecked: this.localAttendanceChecked,
        attendanceStatus: this.localAttendanceStatus,
        idGroup: this.localGroup,
      })
    },

    handleGradeChange() {
      this.$nextTick(() => {
        if (this.classList && this.classList.length > 0) {
          this.localClass = this.classList[0].id;
        } else {
          this.localClass = null;
        }
        this.applyFilter();
      });
    },
    resetFilter() {
      this.localDate = new Date().toISOString().substring(0, 10)
      this.getIdGrade()
      this.getIdClass()
      this.localAttendanceChecked = null
      this.localAttendanceStatus = null
      this.applyFilter()
    },
    getAllGroup() {
      return AttendanceV3Service.getListKidsGroup().then((res) => {
        this.groupList = res.data
        if (this.groupList.length > 0) {
          this.localGroup = this.groupList[0].id
        }
      }).catch(() => {
        NotifyMessage.leftCornerNotificationError("Lỗi dữ liệu!")
      })
    },
    getIdGrade() {
      if (this.gradeOfSchoolList.length > 0) {
        this.localGrade = this.gradeOfSchoolList[0].id;
      }
    },
    getIdClass() {
      if (this.classList && this.classList.length > 0) {
        this.localClass = this.classList[0].id;
      }
    },
  },
  watch: {
    type(v) { this.localType = v; },
    date(v) { this.localDate = v; },
    idClass(v) { this.localClass = v; },
    idGrade(v) { this.localGrade = v; },
    attendanceChecked(v) { this.localAttendanceChecked = v; },
    attendanceStatus(v) { this.localAttendanceStatus = v; },
  }
}
</script>

<!-- Sử dụng scss scoped đồng bộ hoàn toàn style mượt mà của Album -->
<style lang="scss" scoped>
.wrap-item {
  //display: flex;
  align-items: center;
  //gap: 12px;
  //flex-wrap: wrap;
  //padding: 16px 20px;
  background: #ffffff;
  //border: 1px solid #e8edf4;
  border-radius: 14px;
  //box-shadow: 0 4px 14px rgba(31, 45, 61, 0.06);
}

.wrap-toolbar {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.toolbar-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.toolbar-datepicker {
  width: 180px !important;
}

.toolbar-select {
  width: 150px !important;

  &--wide {
    width: 190px !important;
  }
}

.toolbar-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.btn-action {
  border-radius: 10px !important;
  font-weight: 600;
  height: 38px;
  padding: 0 16px;
}

// ─── Ghi đè style Element UI Input gốc ──────────────────────────────────
/deep/ .el-input .el-input__inner,
/deep/ .el-select .el-input__inner {
  border-radius: 10px;
  border-color: #dbe4f0;
  height: 38px;
  line-height: 38px;
  transition: all .2s ease;
}

/deep/ .el-input .el-input__inner:focus,
/deep/ .el-select .el-input__inner:focus {
  border-color: #78a5e7;
  box-shadow: 0 0 0 3px rgba(120, 165, 231, 0.12);
}

.card-title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

.card-subtitle {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #64748b;
}

// ─── Tương thích thiết bị di động (Responsive) ──────────────────────────
@media (max-width: 768px) {
  .toolbar-card {
    flex-direction: column;
    align-items: flex-start;
    border-radius: 12px;
    padding: 14px;
  }
  .toolbar-left, .toolbar-right {
    width: 100%;
  }
  .toolbar-datepicker, .toolbar-select, .toolbar-select--wide {
    width: 100% !important;
  }
  .btn-action {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>